export enum AssessmentCriteriaStatus {
  Incomplete = 2,
  NotYetCompetent = 10,
  Competent = 20,
  Excellent = 30,
}
